import { jsx as _jsx } from "react/jsx-runtime";
export const SvgCompass = (props) => (_jsx("svg", { xmlSpace: 'preserve', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'M12 4 7 17l5-3 5 3z' }) }));
//# sourceMappingURL=compass.js.map